import { combineReducers } from 'redux';

import { enrichedReducer } from './enriched/enriched.reducer';
import type { FormDataState } from './formData.model';
import { inputReducer } from './input/input.reducer';
import { patchedFieldsReducer } from './patchedFields/patchedFields.reducer';
import { pendingEnrichmentReducer } from './pendingEnrichment/pendingEnrichment.reducer';

export const formDataReducer = combineReducers<FormDataState>({
  enriched: enrichedReducer,
  input: inputReducer,
  pendingEnrichment: pendingEnrichmentReducer,
  patchedFields: patchedFieldsReducer,
});
